import { Activity, ChartGantt, FileText, List, Plus } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

import { Button } from '@/components/ui/Button';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/Card';
import { ROUTE_PATHS } from '@/config/constants';

export function AdminDashboard() {
  const navigate = useNavigate();

  function handleCreateCustomerClick() {
    navigate(ROUTE_PATHS.ADMIN_CUSTOMERS_CREATE);
  }

  function handleCreateUserClick() {
    navigate(ROUTE_PATHS.ADMIN_USERS_CREATE);
  }
  function handleListUserClick() {
    navigate(ROUTE_PATHS.ADMIN_USERS);
  }

  function handleCreateTaxonomyClick() {
    navigate(ROUTE_PATHS.ADMIN_TAXONOMY);
  }

  function handleAuditLogsClick() {
    navigate(ROUTE_PATHS.ADMIN_AUDIT_LOGS);
  }

  function handlePromptsListClick() {
    navigate(ROUTE_PATHS.ADMIN_PROMPTS);
  }

  function handleModelsListClick() {
    navigate(ROUTE_PATHS.ADMIN_MODELS);
  }

  function handleListCustomerClick() {
    navigate(ROUTE_PATHS.ADMIN_CUSTOMERS);
  }

  function handleOnBoardingClick() {
    navigate(ROUTE_PATHS.ADMIN_ONBOARDING);
  }

  function handleVoiceToneExportsClick() {
    navigate(ROUTE_PATHS.ADMIN_VOICE_TONE_EXPORTS);
  }

  return (
    <div style={{ minHeight: '100vh' }}>
      <h1 className="mb-8 text-4xl font-bold">Admin Dashboard</h1>
      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        <Card className="flex h-full flex-col">
          <CardHeader>
            <CardTitle>Onboarding Dashboard</CardTitle>
            <CardDescription>View and manage customer metrics</CardDescription>
          </CardHeader>

          <CardContent className="mt-auto">
            <Button className="w-full" onClick={handleOnBoardingClick}>
              <Activity className="mr-2 h-4 w-4" />
              View Onboarding
            </Button>
          </CardContent>
        </Card>

        <Card className="flex h-full flex-col">
          <CardHeader>
            <CardTitle>Customer Management</CardTitle>
            <CardDescription>
              Create and manage customer accounts
            </CardDescription>
          </CardHeader>

          <CardContent className="mt-auto space-y-2">
            <Button
              variant="outline"
              className="w-full bg-white hover:bg-gray-200"
              onClick={handleListCustomerClick}
            >
              <List className="mr-2 h-4 w-4" />
              View All Customers
            </Button>
            <Button className="w-full" onClick={handleCreateCustomerClick}>
              <Plus className="mr-2 h-4 w-4" />
              Create New Customer
            </Button>
          </CardContent>
        </Card>

        <Card className="flex h-full flex-col">
          <CardHeader>
            <CardTitle>User Management</CardTitle>
            <CardDescription>Create and manage user accounts</CardDescription>
          </CardHeader>
          <CardContent className="mt-auto space-y-2">
            <Button
              variant="outline"
              className="w-full bg-white hover:bg-gray-200"
              onClick={handleListUserClick}
            >
              <List className="mr-2 h-4 w-4" />
              View All Users
            </Button>
            <Button className="w-full" onClick={handleCreateUserClick}>
              <Plus className="mr-2 h-4 w-4" />
              Create New User
            </Button>
          </CardContent>
        </Card>

        <Card className="flex h-full flex-col">
          <CardHeader>
            <CardTitle>Taxonomy Management</CardTitle>
            <CardDescription>Create and manage taxonomies</CardDescription>
          </CardHeader>

          <CardContent className="mt-auto">
            <Button className="w-full" onClick={handleCreateTaxonomyClick}>
              <ChartGantt className="mr-2 h-4 w-4" />
              Create/Manage Taxonomy
            </Button>
          </CardContent>
        </Card>

        <Card className="flex h-full flex-col">
          <CardHeader>
            <CardTitle className="text-lg font-semibold">Audit Logs</CardTitle>
            <CardDescription className="text-gray-600">
              Track and analyze system activities
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <Button
              onClick={handleAuditLogsClick}
              className="w-full text-white hover:bg-gray-800"
            >
              <FileText className="mr-2 h-4 w-4" />
              View Audit Logs
            </Button>
          </CardContent>
        </Card>

        <Card className="flex h-full flex-col">
          <CardHeader>
            <CardTitle className="text-lg font-semibold">
              Prompt Management
            </CardTitle>
            <CardDescription className="text-gray-600">
              Create and manage prompts
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <Button
              onClick={handlePromptsListClick}
              className="w-full text-white hover:bg-gray-800"
            >
              <FileText className="mr-2 h-4 w-4" />
              View Prompts and Queries
            </Button>
          </CardContent>
        </Card>

        <Card className="flex h-full flex-col">
          <CardHeader>
            <CardTitle className="text-lg font-semibold">
              Model Management
            </CardTitle>
            <CardDescription className="text-gray-600">
              Create and manage models
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <Button
              onClick={handleModelsListClick}
              className="w-full text-white hover:bg-gray-800"
            >
              <FileText className="mr-2 h-4 w-4" />
              View Models
            </Button>
          </CardContent>
        </Card>

        <Card className="flex h-full flex-col">
          <CardHeader>
            <CardTitle className="text-lg font-semibold">
              Voice Tone Exports
            </CardTitle>
            <CardDescription className="text-gray-600">
              Create and track training file exports
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <Button
              onClick={handleVoiceToneExportsClick}
              className="w-full text-white hover:bg-gray-800"
            >
              <FileText className="mr-2 h-4 w-4" />
              View Exports
            </Button>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
